export const HTTP_STATUS_ERROR = 500;
export const HOSTNAME = 'http://grayfox.ma:8080';
export const RECAPTCHA_SITE_KEY =
    '6LeW3swUAAAAAKboESHUW2E30EUE2LaVd1PkPedZ';